import { render, staticRenderFns } from "./prize_page.vue?vue&type=template&id=1d578e4f&scoped=true&"
import script from "./prize_page.vue?vue&type=script&lang=js&"
export * from "./prize_page.vue?vue&type=script&lang=js&"
import style0 from "./prize_page.vue?vue&type=style&index=0&id=1d578e4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d578e4f",
  null
  
)

export default component.exports